<!-- 我的证书 -->
<template>
  <div class="certificate">
    <div class="wrap">
      <el-table :data="list" empty-text="暂无报名记录">
        <el-table-column label="报名证书" prop="subjectName" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.subjectCode == 'ZYJS'">{{
              row.subjectName + "(" + row.subjectLevel + ")"
            }}</span>
            <span v-else>{{ row.subjectName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="电话" prop="phoneNo"></el-table-column>
        <el-table-column
          prop="workTypeName"
          label="专业名称（岗位、工种）"
          width="180"
        ></el-table-column>
        <el-table-column prop="companyName" label="工作单位"></el-table-column>
        <el-table-column prop="status" label="进度" width="140">
          <template slot-scope="{ row }">
            <el-tag type="info" v-if="row.status == 0">待审核</el-tag>
            <el-tag type="warning" v-if="row.status == 1">报名成功</el-tag>
            <el-tag type="primary" v-if="row.status == 2"
              >培训考试已通过</el-tag
            >
            <el-tag type="success" v-if="row.status == 3">生成证书</el-tag>
            <el-tag type="danger" v-if="row.status == -1">报名失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="noPassReason" label="失败原因"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ip } from "../../util/config";
export default {
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 50,
        status: "",
      },
      subjects: [],
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    currentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getMyApplyRecord(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    onSearch() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },
    // 下载我的证书
    downloadMyCert(row) {
      // 下载证书api
      axios
        .get(ip + "jianxie/certificate-apply-form/front/getcertApplyPdf", {
          params: { certNum: row.certNum },
          responseType: "blob",
          headers: {
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          let url = window.URL.createObjectURL(res.data);
          let a = document.createElement("a");
          a.href = url;
          a.download = row.certNum + ".pdf";
          a.click();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
}
</style>
